// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__VHjLV","productName":"Table_productName__I96KK"};